export var MentionPrefix;
(function (MentionPrefix) {
    MentionPrefix["Member"] = "@";
    MentionPrefix["Record"] = "#";
})(MentionPrefix || (MentionPrefix = {}));
